import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './HolidayBadge.css';

/**
 * HolidayBadge()
 * @param props
 * @returns {*|null}
 * @constructor
 */
export default function HolidayBadge(props) {
  const {
    item, calendarData, onPress, currentMonth, showSunday, users,
  } = props;
  const formattedDate = moment(item).format('YYYY-MM-DD');
  const [data, setData] = useState(null);
  const [isSunday, setIsSunday] = useState(false);

  useEffect(() => {
    if (calendarData) {
      setData((calendarData[formattedDate]) ? calendarData[formattedDate] : null);

      const day = item.day();
      setIsSunday((day === 0));
    }
  }, [calendarData, formattedDate, item]);

  const getStyle = () => {
    if (!moment(item).isSame(moment(currentMonth), 'month')) {
      return { opacity: 0.2 };
    }
    return {};
  };

  const getClass = () => {
    let classNames = 'HolidayBadge';
    if (moment(item).isSame(moment(), 'day')) {
      classNames = `${classNames} Today`;
    }
    if (!showSunday) {
      classNames = `${classNames} WithoutSunday`;
    }
    return classNames;
  };

  if (!showSunday && isSunday) {
    return null;
  }

  const getUserName = (userId) => {
    if (users) {
      const filtered = users.filter((param) => param.userId === userId)[0];
      if (filtered) {
        return `${filtered.firstname[0]}. ${filtered.lastname}`;
      }
    }
    return null;
  };

  const handleOnPressItem = (e, param) => {
    e.stopPropagation();
    onPress(param);
  };

  const renderContent = () => {
    if (data) {
      return data.map((param) => (
        <div
          tabIndex={-1}
          role="button"
          onKeyPress={() => {}}
          className={`HolidayRow ${(param.isStart) ? 'Start' : ''} ${(param.isEnd) ? 'End' : ''}`}
          style={{ backgroundColor: param.color }}
          key={Math.random()}
          onClick={(e) => handleOnPressItem(e, param)}
        >
          {getUserName(param.userId)}
        </div>
      ));
    }
    return null;
  };

  if (calendarData) {
    return (
      <div
        className={getClass()}
        style={getStyle()}
        tabIndex={-1}
        role="button"
        onKeyPress={() => {}}
        onClick={() => onPress(formattedDate)}
      >
        <div className="Container Front">
          <div className="Headline">
            <div className="Left" />
            <div className="DayNumber">
              {moment(item).format('D')}
            </div>
          </div>
          <div className="Content">
            {renderContent()}
          </div>
          <div className="CalendarWeek">
            {`KW ${moment(item).format('WW')}`}
          </div>
        </div>
      </div>
    );
  }
  return null;
}

HolidayBadge.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
  calendarData: PropTypes.instanceOf(Object),
  onPress: PropTypes.func.isRequired,
  currentMonth: PropTypes.instanceOf(Object).isRequired,
  showSunday: PropTypes.bool,
  users: PropTypes.instanceOf(Array).isRequired,
};

HolidayBadge.defaultProps = {
  calendarData: null,
  showSunday: false,
};
